import { useState, useEffect } from 'react';
import { functionOp } from 'store/ducks/DataEntry/Functions';
import useFilters from 'utils/hooks/useFilters';

interface LicensedActivity {
  label: string;
  value: any;
}

const useLicensedActivities = () => {
  const { query } = useFilters();
  const [licensedActivities, setLicensedActivities] = useState<
    LicensedActivity[]
  >([]);

  const fetchLicensedActivities = async () => {
    try {
      const response = await functionOp.fetchLicencedActivitiesPerEntity(
        query.entityId,
        query.entity,
      );
      if (response?.data.selection_licenced_acts) {
        const formattedOptions = response.data.selection_licenced_acts.map(
          (activity: { name: string; id: any }) => ({
            label: activity.name,
            value: activity.id,
          }),
        );
        setLicensedActivities(formattedOptions);
      }
    } catch (error) {
      console.log('Error fetching licensed activities:', error);
    }
  };

  useEffect(() => {
    if (query.entity) {
      fetchLicensedActivities();
    }
  }, [query.entity]);

  return { licensedActivities, refetch: fetchLicensedActivities };
};

export default useLicensedActivities;
